























import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
import { Tree } from 'element-ui';
import { APP } from '@/api/com/MetaPattern/MDA/MD/Base/APP';
import { BaseElement } from '@/api/com/MetaPattern/MDA/MD/Base/BaseElement';
import { TreeNode } from '@/libs/com/MetaPattern/Product/IDE/Util/TreeNode';
import { BaseComponent } from '@/api/com/MetaPattern/MDA/MD/Base/BaseComponent';
import { MDExtendService } from '@/libs/com/MetaPattern/MDA/MD/MDExtendService';
import { EnumComponentType } from '@/api/com/MetaPattern/MDA/MD/Base/EnumComponentType';
import { UIModelComponent } from '@/api/com/MetaPattern/MDA/MD/UIModel/UIModelComponent';

@Component({
  components: {
  }
})
export default class UIPageExplorer extends Vue {
  @Prop() private value: string | BaseElement;
  @Prop() private app: APP;
  private filterText = '';
  filterNode(value: any, data: any) {
    if (!value) return true;
    return data.label.toUpperCase().indexOf(value.toUpperCase()) !== -1;
  }

  @Watch('filterText')
  filter(val: string) {
    (this.$refs.tree as Tree).filter(val);
  }

  get defaultProps() {
    return {
      children: 'children',
      label: 'label',
      id: 'id',
      isLeaf: 'isLeaf'
    };
  }

  get treeData() {
    const comTrees = new Array<TreeNode<BaseElement>>();
    if (this.app) {
      this.app.uIModelComponents.forEach(uiModel => {
        const uiModelCom = new TreeNode<BaseElement>(uiModel.designId, uiModel.rootNamespace, '', false, uiModel);
        comTrees.push(uiModelCom);
      });
    }
    return comTrees;
  }

  async getComponentTrees(designId: string): Promise<Array<TreeNode<BaseElement>>> {
    let trees: Array<TreeNode<BaseElement>> = null;
    const findComponent = this.$store.state.ModuleMD.uiModelComponents.find((item: UIModelComponent) => item.designId === designId);
    let component: BaseComponent;
    if (findComponent) {
      component = findComponent;
      trees = MDExtendService.buildUIPageTree(component);
    } else {
      return new Promise((resolve, reject) => {
        MDExtendService.GetFullComponentAsync(designId, EnumComponentType.UIModel)
          .then((response: BaseComponent) => {
            this.$store.dispatch('ModuleMD/setUIModelComponentAction', response);
            trees = MDExtendService.buildUIPageTree(response);
            resolve(trees);
          })
          .catch(error => {
            // TODO : 格式化错误返回
            reject(error);
          });
      });
    }
    return new Promise((resolve) => resolve(trees));
  }

  loadNode(node: any, resolve: any) {
    if (node.level === 0) {
      return resolve(this.treeData);
    }

    if (node.level === 1) {
      this.getComponentTrees(node.data.id)
        .then((trees) => {
          if (trees !== null) {
            resolve(trees);
          }
        });
    } else {
      return resolve(node.data.children);
    }
  }

  handleNodeClick(data: any, node: any, view: any) {
    this.$emit('onSelectPage', data);
  }
}
